import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface SectionWrapperProps {
  id: string;
  label: string;
  icon: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export function SectionWrapper({ label, icon, isOpen, onToggle, children }: SectionWrapperProps) {
  return (
    <div className="border border-border rounded-xl overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-secondary transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-lg">{icon}</span>
          <h3 className="font-semibold text-foreground text-left">{label}</h3>
        </div>
        <ChevronDown
          className={cn("w-5 h-5 text-muted-foreground transition-transform", {
            "rotate-180": isOpen,
          })}
        />
      </button>
      {isOpen && (
        <div className="border-t border-border p-4 bg-card">{children}</div>
      )}
    </div>
  );
}

export function SubSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mt-6 first:mt-0">
      <h4 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-3">{title}</h4>
      <div className="space-y-4">{children}</div>
    </div>
  );
}

export function FieldLabel({ children, required }: { children: React.ReactNode; required?: boolean }) {
  return (
    <label className="block text-sm font-medium text-foreground mb-1">
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
}

const inputClass =
  "w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20";

export { inputClass };
